
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
import snoowrap from "snoowrap";
import moment from "moment";

const HistoryRepo = RepositoryFactory.get('history')

export const searchHistoryMixin = {
    filters: {
        formatTimestamp(timestamp) {
            return moment.unix(timestamp).format('YY-MM-DD h:mm:ss a')
        },
        truncate(string, value) {
            if (string.length <= value) {
                return string;
            }
            return string.substring(0, value) + '...';
        },
    },
    methods: {
        getSearchHistory(repostOnly) {
            // eslint-disable-next-line no-unused-vars
            const { sortBy, sortDesc, page, itemsPerPage } = this.options
            let results = {
                searches: [],
                reposts: []
            }
            return HistoryRepo.getRecentChecks({
                'params': {
                    'subreddit': this.selectedSubreddit.redditData.name,
                    'limit': itemsPerPage,
                    'offset': (itemsPerPage * page) - itemsPerPage,
                    'repost_only': repostOnly
                }
            })
                .then(searches => {
                    if (searches.status === 'error') {
                        this.$emit('on-alert', {color: 'error', message: searches.data})
                        return results;
                    }
                    let postIds = []
                    searches.data.forEach(post => {
                        postIds.push('t3_' + post.checked_post.post_id)
                    })
                    console.log(postIds);
                    const snoo = new snoowrap({
                        'accessToken': this.$store.getters.token,
                        'userAgent': 'windows.RepostSleuthSite:v0.0.1 (by /u/barrycarey)'
                    })

                    return snoo.getContentByIds(postIds)
                        .then(res => {

                            res.forEach(sub => {
                                let searchResult = searches.data.find(s => s.checked_post.post_id === sub.id);
                                if (searchResult !== null) {
                                    console.log(searchResult.checked_post.created_at)
                                    let searchRecord = {

                                        id: sub.id,
                                        author: searchResult.checked_post.author,
                                        created: searchResult.checked_post.created_at,
                                        title: sub.title,
                                        score: sub.score,
                                        matches: searchResult.search.matches_found,
                                        searchTime: searchResult.search.search_time,
                                        subreddit: this.selectedSubreddit.redditData.name,
                                        memeFilter: searchResult.search.meme_filter,
                                        sameSub: searchResult.search.same_sub,
                                        filterDeadMatches: searchResult.search.filter_dead_matches,
                                        filterOnlyOlder: searchResult.search.only_older_matches,
                                        targetImageMatch: searchResult.search.target_image_match,
                                        targetImageMemeMatch: searchResult.search.target_image_meme_match

                                    }
                                    if (searchResult.search.matches_found > 0) {
                                        results.reposts.push(searchRecord);
                                    }
                                    results.searches.push(searchRecord);
                                }
                            })
                            return results;
                        })
                })
        },


    },
}